import { render, staticRenderFns } from "./CategoryItemAssociation.vue?vue&type=template&id=8ea34aec&"
import script from "./CategoryItemAssociation.vue?vue&type=script&lang=js&"
export * from "./CategoryItemAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports